import { Chip, Stack, Typography } from "@mui/material";
import { useCerLegacyCard } from "./logics";
import { CerCardStyled, classes } from "./styles";

export interface ICerLegacyCardProps {
  startDate: Date;
  endDate: Date;
}

export const CerLegacyCard = ({ startDate, endDate }: ICerLegacyCardProps) => {
  const { cerStartDate, cerEndDate } = useCerLegacyCard(startDate, endDate);

  return (
    <CerCardStyled className={classes.root}>
      <Stack
        direction="row"
        sx={{
          gap: 3,
        }}
      >
        <Typography>{`CE du ${cerStartDate} au ${cerEndDate}`}</Typography>
        {endDate < new Date() ? (
          <Chip label="Terminé" variant="outlined" className={classes.doneChip} size="small" />
        ) : (
          <Chip label="Signé" variant="outlined" className={classes.signedChip} size="small" />
        )}
      </Stack>
    </CerCardStyled>
  );
};
